import React from 'react';
import cn from 'classnames';
import styles from './A_Reaction.module.css';

export type ReactionSize = 'medium' | 'large';

interface A_ReactionProps {
  image: string;
  alt: string;
  size?: ReactionSize;
  className?: string;
  draggable?: boolean;
  onDragStart?: (event: React.DragEvent<HTMLImageElement>) => void;
  onDragEnd?: (event: React.DragEvent<HTMLImageElement>) => void;
}

export default function A_Reaction({
  image,
  alt,
  size = 'medium',
  className,
  draggable = false,
  onDragStart,
  onDragEnd,
}: A_ReactionProps) {
  return (
    <div className={cn(styles.wrapper, styles[size], className)}>
      <img
        src={image}
        alt={alt}
        className={styles.image}
        draggable={draggable}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
      />
    </div>
  );
}
